import type { TemperatureProfile } from '../sim/temperature.ts';
import { NumberField } from './NumberField.tsx';

export interface TemperatureFieldsProps {
  value: TemperatureProfile;
  onChange: (patch: Partial<TemperatureProfile>) => void;
}

/** The four fields that define a temperature-by-elevation profile (low/high elevation and
 * temperature). Shared by the conditions panel's default profile and each timeline event's own
 * profile in the timeline editor. */
export function TemperatureFields({ value, onChange }: TemperatureFieldsProps) {
  return (
    <>
      <NumberField
        label="Low elevation"
        value={value.lowElevation}
        min={0}
        max={2500}
        step={10}
        unit="m"
        onChange={(v) => onChange({ lowElevation: v })}
      />
      <NumberField
        label="Low temp."
        value={value.lowTemp}
        min={-30}
        max={20}
        step={0.5}
        unit="°C"
        decimals={1}
        onChange={(v) => onChange({ lowTemp: v })}
      />
      <NumberField
        label="High elevation"
        value={value.highElevation}
        min={0}
        max={2500}
        step={10}
        unit="m"
        onChange={(v) => onChange({ highElevation: v })}
      />
      <NumberField
        label="High temp."
        value={value.highTemp}
        min={-40}
        max={20}
        step={0.5}
        unit="°C"
        decimals={1}
        onChange={(v) => onChange({ highTemp: v })}
      />
    </>
  );
}
